import { Tag, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { getUsername } from "../..";
import { _User } from "../../../js/parsegenerated";

type Props = {
  user: _User;
};

export const UserTag = observer((props: Props) => {
  const username = getUsername(props.user);

  return (
    <Tooltip
      title={props.user?.get("username")}
      placement="top"
      key={props.user?.id}
    >
      <Tag color="lime">{username}</Tag>
    </Tooltip>
  );
});
